import {
    GET_METAL_RECIPES_LOADING,
    GET_METAL_RECIPES_SUCCESS,
    GET_METAL_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getMetalRecipesSuccess = payload => ({
    type: GET_METAL_RECIPES_SUCCESS,
    payload
})

export const getMetalRecipesFailure = () => ({
    type: GET_METAL_RECIPES_FAILURE
})

export const getMetalRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('metal-recipes', getMetalRecipesSuccess, 0));
}